import React, { useState } from 'react';
import { getData } from '../services/api';
import { useNavigate } from 'react-router-dom';
import { SessionCodeResponse } from '../models/api';
import './Welcome.scss';
import Button from '../components/Button';
import { ReactComponent as ArrowIcon } from '../assets/arrow_forward_large.svg';

const Welcome: React.FC = () => {
  const navigate = useNavigate();
  const [errors, setErrors] = useState<string[]>([]);
  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (code === '') {
      setErrors(['Code is required']);
      return;
    }
    setLoading(true);
    try {
      setErrors([]);
      const result = await getData<SessionCodeResponse>(
        `api/sessions/codes/${code}`
      );

      if (result.success) {
        navigate(`/w/${result.data?.sessionReference}`);
      } else {
        setErrors(result.errors);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="content-page">
      <div className="welcome-container">
        <div className="welcome-area">
          <h1>Welcome to ViewEventNotes</h1>
          <p className="welcome-message">Please enter your event code</p>
          <form onSubmit={submit}>
            <input
              type="text"
              id="code-input"
              required
              placeholder="Event code"
              maxLength={10}
              onChange={(e) => setCode(e.target.value)}
            ></input>
            <Button className="primary" isSubmit={true} isLoading={loading}>
              Go <ArrowIcon />
            </Button>
          </form>
          {errors.length > 0 && (
            <div className="messages error">
              <ul>
                {errors.map((p, i) => (
                  <li key={i}>{p}</li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Welcome;
